const getAlertRescheduleLabel = (dataTotalRequest, approvalTypeOptions) => {
  const isQuotaExist = dataTotalRequest?.remaining > 0;
  const isChangeScheduleAvailable = approvalTypeOptions?.[0].isAvailable;

  if (approvalTypeOptions?.isChangeScheduleAvailable && !isChangeScheduleAvailable) return { key: 'no_available_change_schedule' };

  return isQuotaExist
    ? { key: 'remaining_opportunities', options: { remaining: dataTotalRequest?.remaining, total: dataTotalRequest?.maxRequest } }
    : { key: 'quota_exhausted' };
};

export default getAlertRescheduleLabel;
